<template>
	<div class="page">
		<div class="mainArea">
			<div @click="goback">橙猩视点 > 详情</div>
			<div class="contentinfo">
				<keep-alive>
				  <component :is="currentTab"></component>
				</keep-alive>
			</div>
		</div>
	</div>
</template>
<script>
	import info_20250626 from '../../compenents/20250626.vue'
	import info_20250702 from '../../compenents/20250702.vue'
	import info_20250704 from '../../compenents/20250704.vue'
	import info_20250725 from '../../compenents/20250725.vue'
	import info_20250824 from '../../compenents/20250824.vue'
	import info_20251009 from '../../compenents/20251009.vue'
	import info_20251014 from '../../compenents/20251014.vue'
	import info_20251028 from '../../compenents/20251028.vue'
	import info_20251104 from '../../compenents/20251104.vue'
	import info_20251113 from '../../compenents/20251113.vue'
	import info_20251212 from '../../compenents/20251212.vue'
	import info_20251226 from '../../compenents/20251226.vue'
	import info_20260122 from '../../compenents/20260122.vue'
	import info_20260316 from '../../compenents/20260316.vue'
	export default {
		name: 'Seeinfo',
		components:{
			info_20250626,
			info_20250702,
			info_20250704,
			info_20250725,
			info_20250824,
			info_20251009,
			info_20251014,
			info_20251028,
			info_20251104,
			info_20251113,
			info_20251212,
			info_20251226,
			info_20260122,
			info_20260316,
		},
		data() {
			return {
				isM:false,
				currentTab:''
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.isM=true
			}
		},
		mounted() {
			this.currentTab='info_'+this.$route.query.type			
		},		
		methods: {
			goback(){
				if(this.isM){
					this.$router.push({ path: '/mobile/see'});
				}else{
					this.$router.push({ path: '/pc/see'});
				}
			},			
		}	

	}
</script>
<style lang="less">
	.page{
		text-align: left;
	}
	.orangeTxt1{
		color: rgb(255, 142, 41) !important;
		text-decoration: underline;
	}
	.orangeTxt2{
		color: rgb(255, 142, 41) !important;
	}
	.contentinfo{
		position: relative;
		border-radius: 5px;
		padding:40px;
		background: #fff;
		color: #999;
		margin-top: 20px;
		.top{
			border-bottom: 1px solid #ddd;
			h1{
				color: #000;
				font-size: 30px;
			}
			p{text-align: right;color: #999;padding-bottom: 10px;padding-top: 10px;}
		}
		.center{
			h3{
				color: #000;
				font-size: 24px;
				margin-top: 20px;
			}
			p{
				padding-top:10px;
				padding-bottom:10px;
				line-height: 30px;
				color: #555;
				font-size: 16px;
				b{
					color: #000;
					font-weight: 800;
				}
				span{
					color: rgb(255, 142, 41);
					font-weight: 800;
				}
			}
		}
		img{
			width: 100%;
			margin-top: 10px;
			margin-bottom: 10px;
		}
	}
	
	@media (max-width:800px) {
			.contentinfo{
				padding:20px;
				.top{
					h1{
						font-size: 22px;
					}
				}
				.center{
					h3{
						font-size: 20px;
					}
					p{
						font-size: 14px;
					}
				}				
			}
	}
</style>